import React from 'react';
import { SparklesIcon } from 'lucide-react';
import { GENERAL_ENQUIRY_URL } from '../utils/whatsapp';
import { trackAddToCart } from '../utils/metaPixel';
export function BundleOffer() {
  return <section className="mx-auto max-w-3xl px-5 py-14 sm:px-8 lg:py-20" aria-labelledby="promo-bundle" data-id="element-7" data-mp="xkfd45hfgzwu">
      <div className="rounded-3xl bg-navy px-6 py-10 text-center sm:px-10 sm:py-12" data-id="element-8" data-mp="tjvhj6ci64ct">
        <p className="inline-flex items-center gap-2 rounded-full border border-gold/40 bg-gold/10 px-4 py-1.5 text-[11px] font-bold uppercase tracking-wide text-gold" data-id="element-9" data-mp="5s6fuzdsk3j7">
          <SparklesIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-10" data-mp="el1eha8r7100" />
          Oferta especial de hoy
        </p>

        <h2 id="promo-bundle" className="mt-6 font-display text-3xl font-extrabold leading-tight tracking-tight text-ivory sm:text-4xl" data-id="element-11" data-mp="9u1h63vq2gwz">
          Compra 2 perfumes por{' '}
          <span className="text-gold" data-id="element-12" data-mp="3e9kufdtnbg2v">$129.99</span>
          <br className="hidden sm:block" data-id="element-13" data-mp="3e6ox9rpmgvfh" /> y el tercero va{' '}
          <span className="text-gold" data-id="element-14" data-mp="14hgl8swvtjdf">gratis</span>.
        </h2>

        <a href={GENERAL_ENQUIRY_URL} target="_blank" rel="noreferrer" onClick={() => trackAddToCart({
        contentName: 'Promo 3 perfumes por $129.99',
        value: 129.99
      })} className="shine-sweep group relative mx-auto mt-8 flex w-full max-w-md flex-col items-center overflow-hidden rounded-2xl bg-gold px-6 py-5 shadow-glow transition-colors duration-200 ease-smooth hover:bg-gold-light focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-light focus-visible:ring-offset-2 focus-visible:ring-offset-navy sm:rounded-full sm:py-6" data-id="element-15" data-mp="19hbgt9rlqx4t">
          <span className="font-display text-lg font-extrabold leading-tight text-navy sm:text-xl" data-id="element-16" data-mp="10i7vs08vk7no">
            🔥 Sí, quiero 3 perfumes por $129.99
          </span>
          <span className="mt-1.5 text-[11px] font-semibold uppercase tracking-wide text-navy/70" data-id="element-17" data-mp="2bv0kf26dcfzi">
            Compra 2 y llévate 1 GRATIS · Promo por tiempo limitado
          </span>
        </a>

        <p className="mx-auto mt-4 max-w-sm text-xs leading-relaxed text-ivory/60" data-id="element-18" data-mp="6to2nmc2jt4w">
          Elige tus fragancias favoritas antes de que se agote la promo.
        </p>
      </div>
    </section>;
}